import React, { useEffect, useState } from 'react'
import { scheduleCounts } from '../../util/patientlistfilters'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Button,
  Modal,
  DatePicker,
  Select,
  Radio,
  InputNumber,
  Slider,
  Checkbox,
} from 'antd'
import { FilterFilled, SearchOutlined } from '@ant-design/icons'
import {
  getPatientList,
  setPatientSearch,
  setPatientScheduleView,
} from '../../store/action/patient.action'
import FilterList from './patient.filterlist'
import _ from 'lodash'
import '../../css/patient.scss'
import { useHistory } from 'react-router'
import util from '../../util/util'
import { constants } from '../../constants'
import moment from 'moment'

const { RangePicker } = DatePicker
const { Option } = Select
var form = null

const PatientFilter = (props) => {
  // Counts on the Surgery Date tabs, from the SAME predicates the table
  // filters with (util/patientlistfilters). Without them an empty list is
  // indistinguishable from a clinic with no patients -- which is how two
  // freshly registered patients looked lost on 2026-10-28, while the header
  // above still counted them.
  //
  // Search-aware, so the numbers always describe what clicking a tab would
  // actually show, rather than a clinic-wide total that contradicts the rows
  // on screen. That contradiction is the whole bug.
  const counts = scheduleCounts(props.patients, props.search, props.surgeons)

  const [open, setOpen] = useState(false)
  var history = useHistory()
  const [surgeryOpt, setSurgeryOpt] = useState('none')
  const [surgeryTypes, setSurgeryTypes] = useState([])
  // Quick search is purely client-side: the table filters the already-loaded
  // patient list in memory as you type. We just keep the term in redux so the
  // sibling table component can read it. Local state mirrors it for the input.
  const [searchText, setSearchText] = useState(props.search || '')

  useEffect(() => {
    setSearchText(props.search || '')
  }, [props.search])

  var handleSearch = (value) => {
    var term = value || ''
    setSearchText(term)
    props.setSearch(term)
  }

  const setOpType = (value) => {
    if (value == 'range' && form)
      form.setFieldsValue({
        ...form.getFieldValue(),
        surgeryDate: null,
        optype: 'all',
        surgeryrange: 2,
      })
    if (value == 'date' && form)
      form &&
        form.setFieldsValue({
          ...form.getFieldValue(),
          optype: null,
          surgeryrange: null,
        })
    if (value == 'none')
      form &&
        form.setFieldsValue({
          ...form.getFieldValue(),
          surgeryDate: null,
          optype: null,
          surgeryrange: null,
        })
    form && form.validateFields(['optype', 'surgeryrange', 'surgeryDate'])
    setSurgeryOpt(value)
  }
  useEffect(() => {
    handleModalOpen()
  }, [open])

  useEffect(() => {
    // Use surgery types from stats if available
    if (props.stats?.surgeryTypes) {
      setSurgeryTypes(props.stats.surgeryTypes)
    }
  }, [props.stats])

  var onFinish = (data) => {
    form.validateFields().then((data) => {
      var values = _.pickBy(data, _.identity)
      values.lastdigitsofphone &&
        (values.lastdigitsofphone = parseFloat(values.lastdigitsofphone))
      if (values.score && values.score[0] == 0 && values.score[1] == 0) {
        delete values.score
        delete values.kneescore
        delete values.hipscore
      } else {
        values.hipscore = values.kneescore = values.score
      }
      values.kneescore &&
        (values.kneescore[0] == 0 && values.kneescore[1] == 0
          ? delete values.kneescore
          : (values.kneescore = {
              max: values.kneescore[1],
              min: values.kneescore[0],
            }))
      values.hipscore &&
        (values.hipscore[0] == 0 && values.hipscore[1] == 0
          ? delete values.hipscore
          : (values.hipscore = {
              max: values.hipscore[1],
              min: values.hipscore[0],
            }))
      values.progress &&
        (values.progress[0] == 0 && values.progress[1] == 0
          ? delete values.progress
          : (values.progress = {
              max: values.progress[1],
              min: values.progress[0],
            }))
      values.deviceprogress &&
        (values.deviceprogress[0] == 0 && values.deviceprogress[1] == 0
          ? delete values.deviceprogress
          : (values.deviceprogress = {
              max: values.deviceprogress[1],
              min: values.deviceprogress[0],
            }))
      values.type = values.type
        ? values.type
        : props.filters.type
          ? props.filters.type
          : 'active'
      values.surgeon && !(values.surgeon.length > 0) && delete values.surgeon
      if (surgeryOpt == 'range') {
        if (!values.optype) values.optype = 'all'
        if (!values.surgeryrange) values.surgeryrange = 2
        var range = parseInt(values.surgeryrange)
        if (values.optype == 'pre-op') values.surgerywkrange = [0, range]
        else if (values.optype == 'post-op')
          values.surgerywkrange = [0 - range, 0]
        else values.surgerywkrange = [0 - range, range]
        delete values.surgeryDate
      }

      if (values.surgerytype == 'all') delete values.surgerytype
      values.patients = props.filters?.patients
      var valuesWOScore = values
      // delete valuesWOScore.surgeryrangetype
      // delete valuesWOScore.surgeryrange
      // delete valuesWOScore.optype
      delete valuesWOScore.score
      props.fetchPatient(
        {
          filters: valuesWOScore,
          metadata: { pageSize: 100000, current: 1 },
          customerid: props.customer._id,
          sorter: props.sorter,
        },
        {}
      )
      setOpen(false)
    })
  }
  var handleClearFilter = () => {
    props.setSearch('')
    props.fetchPatient(
      {
        filters: {
          type: 'active',
          surgeon:
            props.decoded?.role == constants.ROLE.SURGEON
              ? [props.user?.surgeon]
              : undefined,
        },
        metadata: { pageSize: 100000, current: 1 },
        customerid: props.customer._id,
        sorter: props.sorter,
      },
      {}
    )
    form && form.resetFields()
    setSurgeryOpt('none')
    if (history.location.state && history.location.state.patientids) {
      let state = { ...history.location.state }
      delete state.patientids
      history.replace({ ...history.location, state })
    }
  }

  var handleModalOpen = () => {
    var data = { ...props.filters }
    console.log('QSW', props.filters, form)

    data.remember = false
    if (data.optype) {
      delete data.surgeryDate
      data.surgeryrangetype = 'range'
    } else if (data.surgeryDate) {
      data.surgeryDate = data.surgeryDate.map((i) => moment(i))
      data.surgeryrangetype = 'date'
    } else data.surgeryrangetype = 'none'

    setOpType(data.surgeryrangetype)
    //delete data.remember
    form &&
      form.setFieldsValue({
        ...data,
        score: props.filters?.score
          ? [props.filters?.core?.min, props.filters?.score.max]
          : undefined,
        kneescore: props.filters?.kneescore
          ? [props.filters?.kneescore?.min, props.filters?.kneescore.max]
          : undefined,
        hipscore: props.filters?.hipscore
          ? [props.filters?.hipscore?.min, props.filters?.hipscore.max]
          : undefined,
        progress: props.filters?.progress
          ? [props.filters?.progress?.min, props.filters?.progress.max]
          : undefined,
        deviceprogress: props.filters?.deviceprogress
          ? [
              props.filters?.deviceprogress?.min,
              props.filters?.deviceprogress.max,
            ]
          : undefined,
      })
  }

  var getSurgeonSelect = () => {
    let options = []
    props.surgeons &&
      props.surgeons.forEach((surgeon, i) => {
        options.push(
          <Option key={i + 1} value={surgeon._id}>
            {` ${surgeon?.name}`}
          </Option>
        )
      })
    return options
  }

  var renderPainOptions = () => {
    var options = [
      { v: 'None' },
      { v: 'Very Mild' },
      { v: 'Mild' },
      { v: 'Moderate' },
      { v: 'Severe' },
    ]
    return options.map((e) => <Option value={e.v}>{e.v}</Option>)
  }

  var applyDefault = (data = false) => {
    if (!data) data = { ...props.defaultFilter }
    if (data.optype) {
      delete data.surgeryDate
      data.surgeryrangetype = 'range'
    } else if (data.surgeryDate) {
      data.surgeryDate = data.surgeryDate.map((i) => moment(i))
      data.surgeryrangetype = 'date'
    } else data.surgeryrangetype = 'none'

    setOpType(data.surgeryrangetype)
    delete data.remember
    form && form.resetFields()
    form && form.setFieldsValue(data)
  }

  var renderCard = () => {
    return (
      <Card bordered={false}>
        <Form
          ref={(e) => (form = e)}
          name='normal_login'
          layout='horizontal'
          // initialValues={defaultValue}
          labelCol={{ span: 7 }}
        >
          {/* <Form.Item name="firstname" label="Firstname">   
                        <Input  placeholder="Firstname" />
                    </Form.Item>
                    <Form.Item name="lastname" label="Lastname" >
                        <Input placeholder="Lastname" />
                    </Form.Item>  */}
          <Form.Item
            hidden={props.decoded?.role == constants.ROLE.SURGEON}
            name='surgeon'
            label='Provider'
          >
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              mode='multiple'
              placeholder='Select Provider'
            >
              {getSurgeonSelect()}
            </Select>
          </Form.Item>
          <Form.Item
            name='lastdigitsofphone'
            label='Last Four Digit Of Phone'
            rules={[
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || value.toString().length == 4) {
                    return Promise.resolve()
                  }
                  return Promise.reject('Please enter 4 digits')
                },
              }),
            ]}
          >
            <Input type='tel' placeholder='Enter Phone' />
          </Form.Item>
          <Form.Item name='lastname_plain' label='Last Name'>
            <Input type='lastname_plain' placeholder='Enter Last Name' />
          </Form.Item>
          <Form.Item name='painlevel' label='Pain Level' hidden='true'>
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder='Select Pain Level'
            >
              {renderPainOptions()}
            </Select>
          </Form.Item>
          <Form.Item name='kneescore' label='Knee Score' hidden='true'>
            {/* <Input type="tel" placeholder="Enter Knee Score"/> */}
            <Slider range marks={{ 0: '0', 100: '100' }} />
          </Form.Item>
          <Form.Item name='hipscore' label='Hip Score' hidden='true'>
            {/* <Input type="tel" placeholder="Enter Hip Score"/> */}
            <Slider range marks={{ 0: '0', 100: '100' }} />
          </Form.Item>
          <Form.Item name='score' label='Hip/Knee Score' hidden='true'>
            {/* <Input type="tel" placeholder="Enter Hip Score"/> */}
            <Slider range marks={{ 0: '0', 100: '100' }} />
          </Form.Item>
          <Form.Item name='progress' label='Exercise Progress' hidden='true'>
            {/* <Input type="tel" placeholder="Enter Knee Score"/> */}
            <Slider range marks={{ 0: '0%', 100: '100%' }} />
          </Form.Item>
          <Form.Item
            name='deviceprogress'
            label='Measurement Progress'
            hidden='true'
          >
            {/* <Input type="tel" placeholder="Enter Knee Score"/> */}
            <Slider range marks={{ 0: '0%', 100: '100%' }} />
          </Form.Item>
          <Form.Item name='surgerytype' label='Surgery Type'>
            <Radio.Group buttonStyle='solid' defaultValue={'all'}>
              {surgeryTypes.map((surgType) => (
                <Radio.Button key={surgType.name} value={surgType.name.toLowerCase()}>
                  {surgType.name.toUpperCase()}
                </Radio.Button>
              ))}
              <Radio.Button value={'all'}>ALL</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item name='surgeryrangetype' label='Surgery Range Type'>
            <Radio.Group
              buttonStyle='solid'
              defaultValue='none'
              onChange={(e) => setOpType(e.target.value)}
            >
              <Radio value='range'>Range</Radio>
              <Radio value='date'>Date</Radio>
              <Radio value='none'>None</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name='optype'
            label='Surgery Time'
            rules={[
              {
                required: surgeryOpt == 'range' ? true : false,
                message: 'Please select surgery time!',
              },
            ]}
          >
            <Radio.Group buttonStyle='solid' disabled={surgeryOpt != 'range'}>
              <Radio.Button value='post-op'>
                {constants.SURGERYTIME.Post}
              </Radio.Button>
              <Radio.Button value='pre-op'>
                {constants.SURGERYTIME.Pre}
              </Radio.Button>
              <Radio.Button value='all'>
                {constants.SURGERYTIME.All}
              </Radio.Button>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            name='surgeryrange'
            label='Surgery Range'
            rules={[
              {
                required: surgeryOpt == 'range' ? true : false,
                message: 'Please select surgery range!',
              },
            ]}
          >
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              disabled={surgeryOpt != 'range'}
              style={{ width: 200 }}
            >
              <Select.Option value={1}>1 Week</Select.Option>
              <Select.Option value={2}>2 Week</Select.Option>
              <Select.Option value={3}>3 Week</Select.Option>
              <Select.Option value={4}>4 Week</Select.Option>
              <Select.Option value={5}>5 Week</Select.Option>
              <Select.Option value={6}>6 Week</Select.Option>
              <Select.Option value={52}>&gt; 6 Week</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item
            name='surgeryDate'
            label='Surgery Date'
            rules={[
              {
                required: surgeryOpt != 'date' ? false : true,
                message: 'Please select date range',
              },
            ]}
          >
            <RangePicker disabled={surgeryOpt != 'date'} />
          </Form.Item>

          <Form.Item name='type' label='Patient Type'>
            <Radio.Group buttonStyle='solid' defaultValue='active'>
              <Radio.Button value='active'>Active</Radio.Button>
              <Radio.Button value='inactive'>Inactive</Radio.Button>
            </Radio.Group>
          </Form.Item>

          <Row flex='100%' justify='space-around'>
            <Col>
              <Button onClick={() => applyDefault()} className='applyFliter'>
                Apply my default filter
              </Button>
            </Col>
            <Col style={{ width: '60%' }}>
              <Form.Item
                name='remember'
                defaultValue={false}
                valuePropName='checked'
                wrapperCol={{ offset: 8, span: 16 }}
              >
                <Checkbox>Set as my default filter</Checkbox>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    )
  }

  return (
    <>
      <div className='filterRow'>
        <div className='filterTopRow'>
          <Input.Search
            className='patientSearch'
            placeholder='Search by name, provider, type (e.g. knee), or surgery date (MM/DD/YYYY)'
            prefix={<SearchOutlined className='searchPrefixIcon' />}
            enterButton={
              <Button type='primary' icon={<SearchOutlined />}>
                Search
              </Button>
            }
            allowClear
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
            onSearch={handleSearch}
          />
          <div className='filterTopActions'>
            <Button
              className={'clearBtn'}
              type='primary'
              onClick={handleClearFilter}
              disabled={
                props.filters && Object.keys(props.filters).length <= 1
              }
            >
              Clear Filter
            </Button>
            <FilterFilled
              id={'patientfilter'}
              className={'filterIcon'}
              onClick={() => {
                setOpen(true)
              }}
            />
          </div>
        </div>
        {/* Schedule view toggle — only meaningful for active patients. When
            viewing inactive patients these filters do not apply, so hide it. */}
        {props.filters?.type !== 'inactive' && (
          <div
            className='scheduleToggleRow'
            style={{ marginTop: 12, display: 'flex', alignItems: 'center' }}
          >
            <span className='scheduleToggleLabel' style={{ marginRight: 8 }}>
              Surgery Date:
            </span>
            <Radio.Group
              buttonStyle='solid'
              value={props.scheduleView || 'scheduled'}
              onChange={(e) => props.setScheduleView(e.target.value)}
            >
              <Radio.Button value='scheduled'>
                {`Scheduled (${counts.scheduled})`}
              </Radio.Button>
              <Radio.Button value='unscheduled'>
                {`Not Scheduled (${counts.unscheduled})`}
              </Radio.Button>
              <Radio.Button value='all'>{`All (${counts.all})`}</Radio.Button>
            </Radio.Group>
          </div>
        )}
        <Row align={'middle'} gutter={[12, 8]} className='filterControls'>
          <Col flex={'auto'}>
            <FilterList />
          </Col>
        </Row>
      </div>
      <Modal
        className={'filterModal'}
        visible={open}
        closable={false}
        maskClosable={false}
        width={'50%'}
        okText={'Filter'}
        onOk={onFinish}
        onCancel={() => setOpen(false)}
      >
        {renderCard()}
      </Modal>
    </>
  )
}

PatientFilter.propTypes = {
  fetchPatient: PropTypes.func.isRequired,
  customer: PropTypes.object,
  metadata: PropTypes.object,
  patients: PropTypes.array,
  surgeons: PropTypes.array,
  filters: PropTypes.object,
  sorter: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    defaultFilter: state.profile.user.filter,
    metadata: state.patient.metadata,
    filters: state.patient.filters,
    patients: state.patient.patients,
    surgeons: state.surgeon.surgeons,
    sorter: state.patient.sorter,
    decoded: util.verifyToken(state.profile.token, true),
    user: state.profile?.user,
    stats: state.patient.stats,
    search: state.patient.search,
    scheduleView: state.patient.scheduleView,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPatient: (params, patients) =>
      dispatch(getPatientList(params, patients)),
    setSearch: (text) => dispatch(setPatientSearch(text)),
    setScheduleView: (view) => dispatch(setPatientScheduleView(view)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientFilter)
